export default __webpack_public_path__ + "static/media/09.905117e7.jpg";